'use strict';

function extDbTranslateConfig() {
    let labels = {};

    return {
        $get: function() {
            return {
                setExtendedLabels: function(dbLabels) {
                    labels = dbLabels;
                },
                getExtendLabels: function() {
                    return labels;
                },
                getExtendLabel: function(labelKey) {
                    return labels[labelKey];
                }
            }
        }
    }
}
export default extDbTranslateConfig


// WEBPACK FOOTER //
// ./src/app/scripts/modules/extDbTranslateConfig.js